import DataSummaryCard from "./DataSummaryCard";
const ChemistComponent = {
  DataSummaryCard,
};

export default ChemistComponent;
